import { ShowBase, useShowContext } from "ra-core";
import { ReferenceField } from "@/components/admin/reference-field";
import { TextField } from "@/components/admin/text-field";
import { EditButton } from "@/components/admin/edit-button";
import { Card, CardContent } from "@/components/ui/card";

import { CompanyAvatar } from "../companies/CompanyAvatar";
import { EmailComposer } from "../email";
import { SMSComposer } from "../sms";
import { UnifiedTimeline } from "../timeline";
import type { Contact } from "../types";
import { Avatar } from "./Avatar";
import { ContactAside } from "./ContactAside";

export const ContactShow = () => (
  <ShowBase>
    <ContactShowContent />
  </ShowBase>
);

const ContactShowContent = () => {
  const { record, isPending } = useShowContext<Contact>();
  if (isPending || !record) return null;

  const contactName = `${record.first_name} ${record.last_name || ""}`.trim();
  const primaryEmail = record.email_jsonb?.[0]?.email || null;

  return (
    <div className="mt-2 mb-2 flex gap-8">
      <div className="flex-1 space-y-4">
        <Card>
          <CardContent>
            <div className="flex">
              <Avatar />
              <div className="ml-2 flex-1">
                <div className="flex items-center gap-2">
                  <h5 className="text-xl font-semibold">
                    {record.first_name} {record.last_name}
                  </h5>
                  <EditButton label="Edit" />
                </div>
                <div className="inline-flex text-sm text-muted-foreground">
                  {record.title}
                  {record.title && record.company_id != null && " at "}
                  {record.company_id != null && (
                    <ReferenceField
                      source="company_id"
                      reference="companies"
                      link="show"
                    >
                      &nbsp;
                      <TextField source="name" />
                    </ReferenceField>
                  )}
                </div>
              </div>
              <div>
                <ReferenceField
                  source="company_id"
                  reference="companies"
                  link="show"
                  className="no-underline"
                >
                  <CompanyAvatar />
                </ReferenceField>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Email Composer */}
        <EmailComposer
          contactId={Number(record.id)}
          contactName={contactName}
          contactEmail={primaryEmail ?? undefined}
        />

        {/* SMS Composer */}
        <SMSComposer
          contactId={Number(record.id)}
          contactName={contactName}
        />

        {/* Unified Activity Timeline - Combines Notes, SMS, Calls */}
        <UnifiedTimeline contactId={Number(record.id)} />
      </div>
      <ContactAside />
    </div>
  );
};
